// extracted by mini-css-extract-plugin
export default {"grid":"styles_grid__2vM8r","title":"styles_title__I9YFf","actions":"styles_actions__maU75","recordLabel":"styles_recordLabel__SLJAf","selectActions":"styles_selectActions__7VzXO"};